var map = {
	"./1.wav": 1159,
	"./10.wav": 1160,
	"./11.wav": 1161,
	"./12.wav": 1162,
	"./13.wav": 1163,
	"./14.wav": 1164,
	"./15.wav": 1165,
	"./16.wav": 1166,
	"./17.wav": 1167,
	"./18.wav": 1168,
	"./19.wav": 1169,
	"./2.wav": 1170,
	"./20.wav": 1171,
	"./21.wav": 1172,
	"./22.wav": 1173,
	"./23.wav": 1174,
	"./24.wav": 1175,
	"./25.wav": 1176,
	"./26.wav": 1177,
	"./27.wav": 1178,
	"./28.wav": 1179,
	"./29.wav": 1180,
	"./3.wav": 1181,
	"./30.wav": 1182,
	"./4.wav": 1183,
	"./5.wav": 1184,
	"./6.wav": 1185,
	"./7.wav": 1186,
	"./8.wav": 1187,
	"./9.wav": 1188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 674;